/* istanbul ignore file */
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "./core/i18n/config.ts";
import { HelmetProvider } from "react-helmet-async";
import { Agentation } from "agentation";
import { initDatadog } from "./config/datadog-rum";
import { setupGlobalErrorHandlers } from "./lib/rum-actions";
import { getEnv, setViteEnv } from "./shared/utils/env";
import { httpClient } from "./lib/http-client/http-client";

// Initialize DataDog RUM and Logs BEFORE React renders
initDatadog();

// RUM-042: Setup global error handlers for unhandled errors
setupGlobalErrorHandlers();

// Expose Vite env for unit tests / non-Vite runtimes.
setViteEnv(import.meta.env as unknown as Record<string, unknown>);
// Patch singleton http client baseURL after env is available.
httpClient.setBaseURL(getEnv("VITE_API_URL"));

// createRoot(document.getElementById('root')!).render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
// )

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
    {import.meta.env.DEV && <Agentation />}
  </HelmetProvider>
);
